import { z } from "zod";

import { PAGE_NUMBER_OPTIONS } from "../../../config";

export const AdminLocationAlertsQueryParamsSchema = z.object({
  internal_label_name: z.string().optional(),
  sort: z.string().optional(),
  order: z.string().optional(),
  limit: z.number(),
  offset: z.number()
});

export type AdminLocationAlertsQueryParams = z.infer<
  typeof AdminLocationAlertsQueryParamsSchema
>;

export const defaultAdminLocationAlertsQueryParams: AdminLocationAlertsQueryParams =
  {
    internal_label_name: "",
    sort: "created_at",
    order: "desc",
    limit: PAGE_NUMBER_OPTIONS[0],
    offset: 0
  };
